import React, { PropTypes, Component } from 'react';
import ParticipateButtons from 'project/containers/participate_buttons';
import InfoFormImage from 'project/components/participate_form/info_form_image';

/**
 * Participate info step for image entries.
 *
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
export default class InfoStepImage extends Component {
  constructor(props) {
    super(props);
    this.state = { entry: { ...props.entry, licensing: {
      type: '',
      assetTypes: {
        fonts: false,
        images: false,
      },
      assetValues: {
        fonts: '',
        images: '',
      }
    } } };

    this.updateEntryState = this.updateEntryState.bind(this);
    this.updateDescription = this.updateDescription.bind(this);
    this.updateFonts = this.updateFonts.bind(this);
    this.updateImages = this.updateImages.bind(this);
    this.setLicensingType = this.setLicensingType.bind(this);
    this.setLicensingAssets = this.setLicensingAssets.bind(this);
  }

  setLicensingType(type) {
    const entry = { ...this.state.entry };
    entry.licensing.type = type;
    this.updateEntryState(entry);
  }

  setLicensingAssets(value) {
    const entry = { ...this.state.entry };
    const checked = !entry.licensing.assetTypes[value];
    entry.licensing.assetTypes[value] = checked;
    /* clear price or set to 0 on toggle */
    entry.licensing.assetValues[value] = checked? 0 : '';
    this.updateEntryState(entry);
  }

  updateFonts(value) {
    const entry = { ...this.state.entry };
    entry.licensing.assetValues.fonts = value;
    this.updateEntryState(entry);
  }

  updateImages(value) {
    const entry = { ...this.state.entry };
    entry.licensing.assetValues.images = value;
    this.updateEntryState(entry);
  }

  updateDescription(event) {
    const entry = { ...this.state.entry };
    entry.description = event.target.value;

    this.updateEntryState(entry);
  }

  updateEntryState(entry) {
    this.setState({ entry });
  }

  isFormValid() {
    const { entry } = this.state;
    const { licensing } = entry;
    let valid = entry.description !== '' && licensing.type !== '';

    if (licensing.type === 'partial') {
      valid = valid && (licensing.assetTypes.fonts || licensing.assetTypes.images);
    }

    return valid;
  }

  render() {
    const { entry } = this.state;
    const { onChangeEntry, isRevision, revision, onSubmitParticipateForm,
            submissionError, submittingForm } = this.props

    return (
      <div className="participate-step info-step">
        <div className="modal-header">
          <h5>Submit Entry</h5>
        </div>
         <div className="modal-content">
          <div className="row expanded collapse">
            <div className="medium-4 columns">
              <div className="participate-sidebar">
                <section className="sidebar-section">
                  <h3>Thumbnail</h3>
                  <img className="thumbnail-wrap" src={entry.thumbnail} alt="entry thumbnail" />
                  <a href="#"
                    className="change-revision"
                    onClick={(e) => {onChangeEntry(e, false);}}
                  >Change</a>
                </section>
                {isRevision &&
                <section className="sidebar-section">
                  <h3>Revision of</h3>
                  <img className="thumbnail-wrap" src={revision.thumbnail} />
                  <a href="#"
                    className="change-revision"
                    onClick={(e) => { onChangeEntry(e, true); }}
                  >Change</a>
                </section>
                }
              </div>
            </div>
            <InfoFormImage
              entry={entry}
              updateDescription={this.updateDescription}
              setLicensingType={this.setLicensingType}
              setLicensingAssets={this.setLicensingAssets}
              updateFonts={this.updateFonts}
              updateImages={this.updateImages}
            />
          </div>
          <div className="modal-actions right">
            <ParticipateButtons
              action={() => { onSubmitParticipateForm(this.state.entry); }}
              nextActive={this.isFormValid()}
              onToggleForm={this.props.onCloseForm}
              actionError={submissionError}
              actionProcessing={submittingForm}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./project/components/participate_form/info_step_image.jsx